module.exports = __webpack_public_path__ + "static/media/Rectangle938.1e91612e.svg";